import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStatusPagePreviewRoute: InvariantJiraRoute = {
	name: 'communications-status-page-preview',
	path: '/jira/communications/status-page/preview/:pageId',
};
